import { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  fileSelector,
  folderSelector,
  loadingSelector,
} from '../selectors/media'
import mediaActions from '../actions/media'

export const useMedia = () => {
  const mediaFile = useSelector(fileSelector)
  const mediaFolder = useSelector(folderSelector)
  const loading = useSelector(loadingSelector)
  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(mediaActions, dispatch),
    [dispatch],
  )

  return useMemo(
    () => ({
      actions,
      mediaFile,
      mediaFolder,
      loading,
    }),
    [actions, mediaFile, mediaFolder, loading],
  )
}
